import { forwardRef } from 'react';
import { IconProps } from '../iconTypes';
const SVGIcon = forwardRef<SVGSVGElement, IconProps>(({
  size = 14,
  ...props
}, svgRef) => {
  if (size) {
    props.width = size;
    props.height = size;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512" ref={svgRef} {...props}><path d="M143 505c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V280h368c13.3 0 24-10.7 24-24s-10.7-24-24-24H440V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112v150.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm-7-313h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v136zm304 128h-48v136c0 13.3 10.7 24 24 24s24-10.7 24-24V320z" /></svg>;
});
SVGIcon.displayName = "RegularArrowDownUpAcrossLine";
export default SVGIcon;